class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.buyButtons = null;
    this.submitButton = null;
    this.stickyButton = null;
    this.observer = null;
  }

  connectedCallback() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    const sectionId = this.dataset.sectionId;
    const productInfo = document.querySelector(`#ProductInfo-${sectionId}`);
    if (!productInfo) return;

    this.buyButtons = productInfo.querySelector('.product-form__buttons');
    this.submitButton = productInfo.querySelector('[type="submit"][name="add"]');
    this.stickyButton = this.querySelector('[data-sticky-add]');

    if (!this.buyButtons || !this.submitButton || !this.stickyButton) return;

    this.stickyButton.addEventListener('click', () => {
      this.submitButton.click();
    });

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px' }
    );

    this.observer.observe(this.buyButtons);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('product-sticky-bar')) {
  customElements.define('product-sticky-bar', ProductStickyBar);
}
